import { DateOfBirth } from './persons/DateOfBirth';
import { FirstName } from './persons/FirstName';
import { HomeAddress } from './persons/HomeAddress';
import { LastName } from './persons/LastName';
import { PersonId } from './persons/PersonId';
import { PersonIdentityDocument } from './persons/PersonIdentityDocument';
import { PersonProofOfAddress } from './persons/PersonProofOfAddress';
import { PersonRole } from './persons/PersonRole';
import { PersonalIdentifier } from './persons/PersonalIdentifier';
export const PersonsItem = {
    date_of_birth: DateOfBirth,
    first_name: FirstName,
    home_address: HomeAddress,
    last_name: LastName,
    person_id: PersonId,
    person_identity_document: PersonIdentityDocument,
    person_proof_of_address: PersonProofOfAddress,
    person_role: PersonRole,
    personal_identifier: PersonalIdentifier,
};
